import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-problem',
  templateUrl: './report-problem.component.html',
  styleUrls: ['./report-problem.component.scss'],
})
export class ReportProblemComponent implements OnInit {
  problem = '';

  isIOS = false;

  constructor(
    private settingService: SettingService,
    private snackBarService: SnackBarService
  ) {
    this.isIOS = this.isIos();
  }

  ngOnInit() {
    setTimeout(() => {
      if (!this.isIOS) {
        document.getElementById('textarea').focus();
      }
      this.autoGrow();
    }, 100);
  }

  back() {
    this.settingService.goBack();
  }

  send() {
    // console.log('saved', this.problem);
    if (this.problem !== '') {
      this.settingService.sendProblem(this.problem).then((res) => {
        if (res.isSuccess()) {
          this.snackBarService.showSnackBar('گزارش شما با موفقیت ثبت شد.');
          setTimeout(() => {
            this.back();
          }, 1000);
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    } else {
      this.snackBarService.showSnackBar('لطفا مشکل یا نظر خود را بنویسید');
    }
  }

  autoGrow() {
    document.getElementById('textarea').style.height = '5px';
    document.getElementById('textarea').style.height =
      document.getElementById('textarea').scrollHeight - 32 + 'px';
    // document.getElementById('bioHolder').style.height = (document.getElementById('textarea').scrollHeight + 9).toString() + 'px';
  }

  isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };
}
